export const statsData = [
  { id: 1, title: "Current Teachers", stat: 19 },
  {
    id: 2,
    title: "Current Students",
    stat: 250,
  },
  { id: 3, title: "Total Visitors", stat: 17945 },
  {
    id: 4,
    title: "Total Visits",
    stat: 85460,
  },
];
